import { graphql, useLazyLoadQuery } from "react-relay";

import type { entityOnelineMenuQueueItemsEdge$key } from "scmp-app/queries/__generated__/entityOnelineMenuQueueItemsEdge.graphql";
import type { navigationQueueItemsEdge$key } from "scmp-app/queries/__generated__/navigationQueueItemsEdge.graphql";
import type { useOnelineMenuItemsQuery } from "scmp-app/queries/__generated__/useOnelineMenuItemsQuery.graphql";

type MenuItems = entityOnelineMenuQueueItemsEdge$key & navigationQueueItemsEdge$key;

export const usePostMagazineOnelineMenuItems = (): MenuItems => {
  const queryReference = useLazyLoadQuery<useOnelineMenuItemsQuery>(
    graphql`
      query useOnelineMenuItemsQuery {
        postMagSection: section(filter: { entityId: "71" }) {
          subSections {
            items {
              edges {
                ...entityOnelineMenuQueueItemsEdge
                ...navigationQueueItemsEdge
              }
            }
          }
        }
      }
    `,
    {},
  );

  return queryReference.postMagSection?.subSections?.items?.edges ?? [];
};
